import { Injectable } from '@angular/core';
import { LocationGroup } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import { Queries } from './graphql/queries';

@Injectable({
  providedIn: 'root'
})
export class LocationGroupApi {
  constructor(
    private apollo: Apollo,
    private queries: Queries,
  ) {}

  async searchOne(id: string): Promise<LocationGroup> {
    return this.apollo.query({
      query: this.queries.searchLocationGroup(),
      variables: { id }
    }).toPromise()
      .then(({ data }) => {
        return data['locationGroup'];
      });
  }
}
